import http from 'util/http'

/**
 * 文章列表
 * @param {number} label_type 标签类别【经传家事1、经传人2】
 * @param {number} label_id 	标签ID
 * @param {number} type 文章类型【视频1000101、文章1000102】
 * @param {number} page 页数
 * @param {number} limit 每页数量
 * @param {number} project 项目【默认soft】
 */
export function getFamilyArticleList({
  label_type,
  label_id,
  type,
  page,
  limit = 6,
  project = 'soft',
}: {
  label_type?: number
  label_id?: number
  type?: number
  page?: number
  limit?: number
  project?: string
}) {
  return http.get('/newxyrj/public/home/list', {
    label_type,
    label_id,
    type,
    page,
    limit,
    project,
  })
}

/**
 * 文章推荐列表
 * @param {number} label_type 标签类别【经传家事1、经传人2】
 * @param {number} type 文章类型【视频1000101、文章1000102】
 * @param {number} limit 每页数量
 * @param {number} project 项目【默认soft】
 */
export function getFamilyHotArticleList({
  label_type,
  type,
  limit = 5,
  project = 'soft',
}: {
  label_type?: number
  type?: number
  limit?: number
  project?: string
}) {
  return http.get('/newxyrj/public/home/hot/list', {
    label_type,
    type,
    limit,
    project,
  })
}

/**
 * 文章详情
 * @param {number} article_id 文章id
 * @param {number} pageindex 页码
 * @param {number} pagesize 每页大小
 * @param {number} token token
 */
export function getFamilyArticleDetial({
  article_id,
  token,
}: {
  article_id: number
  token?: string
}) {
  return http.get('/newxyrj/public/article/id', {
    id: article_id,
  })
}

/**
 * 征文公告列表
 * @param {number} id 公告ID
 * @param {number} limit 数量
 */
export function getFamilyActivityList({
  id,
  limit = 999,
}: {
  id?: any
  limit?: number
}) {
  return http.get('/newxyrj/public/solicit/activity/list', {
    id,
    limit,
  })
}

/**
 * 征文 banner
 */
export function getFamilyActivityBanner() {
  return http.get('/newxyrj/public/banner/list', {
    module: 5000109,
  })
}

/**
 * 征文 落地页
 */
export function getFamilyActivityIntroDuce() {
  return http.get('/newxyrj/public/solicit/activity/introduce', {})
}

/**
 * 征文 详情
 * @param {number} id 公告ID
 */
export function getFamilyActivityDetail({ id }: { id: number }) {
  return http.get('/newxyrj/public/solicit/activity/detail', {
    id,
  })
}

/**
 * 标签列表
 * @param {number} label_type 标签类别【经传家事1、经传人2】
 * @param {number} project 项目【默认soft】
 */
export function getFamilyLabelList({
  label_type,
  project = 'soft',
}: {
  label_type?: number
  project?: string
}) {
  return http.get('/newxyrj/public/home/label/list', {
    label_type,
    project,
  })
}

/**
 * 资质牌照列表
 * @param {number} page 页码
 * @param {number} limit 数量
 */
export function getFamilyLicenceList({
  page = 1,
  limit,
}: {
  page?: number
  limit?: number
}) {
  return http.get('/newxyrj/public/qualify/licence/list', {
    page,
    limit,
  })
}

/**
 * 出国游 获取年份
 */
export function getFamilyTravelYear() {
  return http.get('/newxyrj/public/travel/abroad/year', {})
}

/**
 * 出国游 详情
 * @param {number} the_year 年份
 */

export function getFamilyTravelDetail({ the_year }: { the_year: number }) {
  return http.get('/newxyrj/public/travel/abroad/detail', { the_year })
}

/**
 * 出国游 图集
 * @param {number} the_year 年份
 * @param {number} page 页码
 * @param {number} limit 数量
 */

export function getFamilyTravelPhotos({
  the_year,
  page = 1,
}: {
  the_year: number
  page?: number
}) {
  return http.get('/newxyrj/public/travel/abroad/photos', {
    the_year,
    page,
    limit: 12,
  })
}
